module.exports = __webpack_public_path__ + "img/项目场景_班组培训.6314ce30.jpg";